import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppProvider";
import CalendarPage from "./pages/CalendarPage";
import HabitPage from "./pages/HabitPage";
import SettingsPage from "./pages/SettingsPage";

const App = () => (
  <AppProvider>
    <Routes>
      <Route index element={<CalendarPage />} />
      <Route path="/habit/:id" element={<HabitPage />} />
      <Route path="/settings" element={<SettingsPage />} />
    </Routes>
  </AppProvider>
);

export default App;
